import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { keyboardLayouts } from '../../layouts/layouts';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-keyboard',
  standalone: true,
  imports: [NgFor],
  templateUrl: './keyboard.component.html',
  styleUrl: './keyboard.component.scss',
})
export class KeyboardComponent implements OnInit {
  @Output() key = new EventEmitter<string>();
  @Input() greyedKeys: string[] = [];
  keyboardLayout: string[][] = [];

  ngOnInit() {
    this.keyboardLayout = (
      keyboardLayouts.find((l) => l.name === 'english')?.layout || []
    ).map((line) => {
      return line.replace('{bksp}', '⌫').split(' ');
    });
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.key.emit(event.key);
  }

  onKey(k: string) {
    if (k === '⌫') {
      this.key.emit('Backspace');
    } else {
      this.key.emit(k);
    }
  }

  isGreyed(k: string) {
    return this.greyedKeys.includes(k)
      ? 'rgba(255, 255, 255, 0.2)'
      : 'transparent';
  }
}
